import { DateTime as d } from "luxon";
import { DATE_TYPE, DateTimeFormat } from "../components/utils";
import i18next from 'i18next';

export const getLocalizedTaxSyntex = (country?: string) => {
  if (country === "United States") {
    return i18next.t("root:taxFees");
  } else {
    return i18next.t("root:vatTax");
  }
}

export const getLocalizedBookingSyntex = (country?: string) => {
  if (country === "United States") {
    return i18next.t("root:reservation")
  } else {
    return i18next.t("root:booking")
  }
}


export const getLocalizedCancelBookingSyntex = (country?: string) => {
  if (country === "United States") {
    return "Cancel Reservation";
  } else {
    return i18next.t("root:cancelBooking");
  }
}

export const getLocalizedBookedSyntex = (country?: string) => {
  if (country === "United States") {
    return "Reserved";
  } else {
    return i18next.t("root:booked");
  }
}
export const getLocalizedOrganisationSyntex = (country?: string) => {
  if (country === "United States") {
    return "Location";
  } else {
    return i18next.t("root:organisation");
  }
}

export const getLocalizedRASyntex = (country?: string) => {
  if (country === "United States") {
    return "Contract";
  } else {
    return i18next.t("root:rentalAgreement");
  }
}

export const getLocalizedVatNumberSyntex = (country?: string) => {
  if (country === "United States") {
    return "Tax number";
  } else {
    return i18next.t("root:vatNumber");
  }
}

export const getLocalizedInsuranceNumberSyntex = (country?: string) => {
  if (country === "United States") {
    return "Driver Insurance Number";
  } else {
    return i18next.t("root:nationalInsuranceNumber");
  }
}

export const getLocalizedSundrySyntex = (country?: string) => {
  if (country === "United States") {
    return "Past Due";
  } else {
    return i18next.t("root:sundry");
  }
}

export const getLocalizedDateFormat = (
  country: string,
  date: string,
  dateType: string,
  timeZone?: string
) => {
  if (country === "United States") {
    if (dateType === DATE_TYPE.EXPANDED) {
      return d.fromISO(date).setZone(timeZone).toFormat(DateTimeFormat.US_DATE_EXPANDED);
    }
    return d.fromISO(date).setZone(timeZone).toFormat(DateTimeFormat.US_DATE_CONDENSED);
  } else {
    if (dateType === DATE_TYPE.EXPANDED) {
      return d.fromISO(date).setZone(timeZone).toFormat(DateTimeFormat.DEFAULT_DATE_EXPANDED);
    }
    return d.fromISO(date).setZone(timeZone).toFormat(DateTimeFormat.DEFAULT_DATE_CONDENSED);
  }
};

export const getLocalizedDateFormatString = (country: string, dateType: string) => {
  if (country === "United States") {
    if (dateType === DATE_TYPE.EXPANDED) {
      return DateTimeFormat.US_DATE_EXPANDED;
    }
    return DateTimeFormat.US_DATE_CONDENSED;
  } else {
    if (dateType === DATE_TYPE.EXPANDED) {
      return DateTimeFormat.DEFAULT_DATE_EXPANDED;
    }
    return DateTimeFormat.DEFAULT_DATE_CONDENSED;
  }
}


export const getDefaultCountryCode = (country?: string) => {
  if (country === "United States") {
    return "US";
  } else {
    return "GB";
  }
}

export const getLocalisedLicense = (country: string) => {
  if(country === "United States")
    return 'License';
  else {
    return i18next.t("misc:licence");
  }
}

export const getLocalizedEnglishFlag = (country: string) => {
  if(country === "United States") {
    return "🇺🇸"
  }
  return "🇬🇧"
}

export const getLocalizedAuthorisedSignatorySyntex = (country: string) => {
  if (country === "United States") {
    return "Authorized Signatory";
  } else {
    return i18next.t('root:authorisedSignatory');
  }
};

export const isUKOrg = (country: string) => {
  return ["United Kingdom", "UK"].includes(country);
};
